import CustomContainer from "../../components/common/CustomContainer"
import styles from "../../assets/styles/appointments.module.css"
import { Tab, Tabs } from "@mui/material"
import { CustomTabPanel, a11yProps } from "../../components/common/CustomTabPanel"
import { useState } from "react"
import Scheduled from "../../components/healthcheckups/Scheduled"
import CollectedTable from "../../components/healthcheckups/CollectedTable"
import ReportReceived from "../../components/healthcheckups/ReportReceived"
import Requested from "../../components/healthcheckups/RequestedTable"
import Cancelled from "../../components/healthcheckups/Cancelled"

const HealthCheckups = () => {
    const [value, setValue] = useState(0);
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    // <MenuItem value="0">All</MenuItem>
    // <MenuItem value="1">Scheduled</MenuItem>
    // <MenuItem value="2">Completed</MenuItem>
    // <MenuItem value="3">Pending</MenuItem>
    // <MenuItem value="4">Cancelled</MenuItem>
    // <MenuItem value="5">Rescheduled</MenuItem>

    return (
        <CustomContainer>
            <div className={'AllPageMain'}>
                <div className={'HeadAndButton'}>
                    <h2>Health checkup request</h2>
                </div>
                <div className={styles.appointmentsMain}>
                    <Tabs value={value} onChange={handleChange} className="custumTabs">
                        <Tab label="Requested" {...a11yProps(0)} />
                        <Tab label="Scheduled" {...a11yProps(1)} />
                        <Tab label="Cancelled" {...a11yProps(2)} />
                        <Tab label="Collected" {...a11yProps(3)} />
                        <Tab label="Report received" {...a11yProps(4)} />
                    </Tabs>
                    <CustomTabPanel value={value} index={0}>
                        <Requested />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                        <Scheduled />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={2}>
                        <Cancelled />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={3}>
                        <CollectedTable />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={4}>
                        <ReportReceived />
                    </CustomTabPanel>
                </div>
            </div>
        </CustomContainer>
    )
}

export default HealthCheckups